  <div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName">
    {{ labelName}}
    <span class="optional" *ngIf="subLabelName">{{subLabelName}}</span>
    <span class="optional" *ngIf="!isRequiredField && showOptionalLabel">({{ OPTIONAL }})</span>
  </div>
  <div *ngIf="readOnlyMode" class="readOnly">{{inputFormControl.value}}</div>
  <div *ngIf="!readOnlyMode" class="input-section">
    <input
      type="text"
      [ngClass]="
        inputFormControl &&
        (submitted || inputFormControl.touched) &&
        inputFormControl.errors
          ? 'error-input'
          : ''
      "
      [formControl]="inputFormControl"
      placeholder="{{ placeHolder }}"
    />
    <i *ngIf="!inputFormControl?.value" class="fa fa-search search-icon" aria-hidden="true"></i>
    <i *ngIf="inputFormControl?.value" class="fa fa-times-circle search-icon" aria-hidden="true" (click)="clear()"></i>

    <div class="search-bar-result" *ngIf="!hideList && users && searchTxt && searchTxt.length">
      <div
        tabindex="2"
        class="list cursor-pointer"
        *ngFor="let item of users; let i = index"
        (click)="onSelect(item)"
      >
      <span class="users">
        <span >{{ item.firstName }} {{item.lastName}}</span> -
        <!-- <div class="spacer"></div> -->
        <span class="disable-txt">{{ item.currentPosition }}</span>
      </span>
      </div>
    </div>
  </div>
  <div
    class="error"
    *ngIf="
      inputFormControl &&
      !readOnlyMode &&
      (submitted || inputFormControl.touched) &&
      inputFormControl.errors
    "
  >
    <div *ngIf="inputFormControl.errors.required">
      {{ labelName }} is required.
    </div>
  </div>
